import { render, staticRenderFns } from "./department-list.vue?vue&type=template&id=87039a32&scoped=true"
import script from "./department-list.vue?vue&type=script&lang=js"
export * from "./department-list.vue?vue&type=script&lang=js"
import style0 from "./department-list.vue?vue&type=style&index=0&id=87039a32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87039a32",
  null
  
)

export default component.exports